<template>
<div style="height:auto;" >

<!-- 文档数据 -->
<md-list-collect></md-list-collect>

</div>
</template>

<script>
	
import MdListCollect  from '@/components/MdListCollect.vue'
// // @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Desk',
  data(){
    return {
      
    }
  },
  mounted(){
    
  },
  components: {
    MdListCollect,
  }
}
</script>
<style scoped lang="scss">
html,
body {
  /*设置内部填充为0，几个布局元素之间没有间距*/
  padding: 0px;
  /*外部间距也是如此设置*/
  margin: 0px;
  /*统一设置高度为100%*/
  height: 100%;
}
</style>